import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import MuiDivider from "@material-ui/core/Divider";
import classNames from "classnames";
export class Divider extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        absolute,
        id,
        component,
        className,
        flexItem,
        orientation,
        variant
      } = this.props;
      const passedProps = {
        absolute,
        id,
        component,
        flexItem,
        orientation,
        variant
      };
      return /*#__PURE__*/React.createElement(MuiDivider, _extends({
        className: classNames("prmbl-divider", className)
      }, passedProps));
    });
  }
}
_defineProperty(Divider, "propTypes", {
  /**
   * The html id.
   */
  id: PropTypes.string,
  /**
   * Sets an absolute position with left and top set to 0px.
   */
  absolute: PropTypes.bool,
  /**
   *  The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container. (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   */
  light: PropTypes.bool,
  /**
   * The divider orientation
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["fullWidth", "inset", "middle"])
});
_defineProperty(Divider, "defaultProps", {
  absolute: false,
  component: "hr",
  flexItem: false,
  light: false,
  orientation: "horizontal",
  variant: "fullWidth"
});
export default Divider;